import React from 'react'
import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    ModalFooter,
    Image,
    Flex,
} from '@chakra-ui/react'
import helpMenu from '../../../assets/images/helpMenuUser.png'

interface IBModalWelcomeProps {
    isOpen: boolean;
    onClose: () => void;
    isloading?: boolean;
    title: string;
    textBody?: string;
    buttonActionText: string;
    buttonCancel?: string;
    buttonAction?: () => void;
    bodyComponent?: React.ReactNode;
}

const IBModalWelcome: React.FC<IBModalWelcomeProps> = ({ isOpen, onClose, isloading, title, textBody, buttonCancel, buttonActionText, buttonAction, bodyComponent }) => (
    <Modal isOpen={isOpen} onClose={onClose} size='3xl' >
        <ModalOverlay />
        <ModalContent p='24px' minWidth='760'>
            <ModalCloseButton fontSize='16px'/>
            <Flex flexDirection={['column', 'row']} pt='30px' maxW='760px'>
                <Flex flex={1} flexDirection="column" minW='356px' p={0}>
                    
                    <ModalHeader style={{ padding: 0 }} textAlign='left' paddingBottom='16px' maxW='280px' >
                        <Text data-testid='alertTitle' textStyle='h3'>{title}</Text>
                    </ModalHeader>

                    <ModalBody style={{ padding: '16px 0 0 0' }} textAlign='left' maxW='280px'>
                        <Text textStyle='bodyMd'>{textBody}</Text>
                        {bodyComponent}
                    </ModalBody>

                    <ModalFooter style={{ padding: 0 }} justifyContent='left'>
                        {buttonCancel &&
                            <Button 
                                onClick={onClose} 
                                minW='82px' 
                                variant='primary-outline' 
                                height='40px' 
                                mr='12px' 
                                color='primary.500' 
                                style={{ fontSize: '13px' }}
                            >
                                {buttonCancel}
                            </Button>
                        }
                        <Button onClick={buttonAction} minW='101px' borderRadius='8px' isLoading={isloading} data-testid='btn-action'>
                            {buttonActionText}
                        </Button>
                    </ModalFooter>

                </Flex>
                <Flex flex={1} maxW='340px' >
                    <Image src={helpMenu} alt="Image" w="340px" h="280px" />
                </Flex>
            </Flex>
        </ ModalContent>
    </Modal >
)
export default IBModalWelcome